import React, {Component} from "react";
import ReactDOM from "react-dom";
import {Var} from "../../../App";
import PropTypes from "prop-types";
import './index.css';
import {Calendar} from "react-datepicker2";
import moment from "jalali-moment";
import Resource from "../../../Resource";
import Notif from "../../Notif";

class Date extends Component {
    constructor (props = {}) {
        super(props);

        this.state = {
            disabled: false,
            readOnly: false,
            error: null,
            value: props.value,
            id: `inp_${Var.shuffle('string', 6)}`,
            typed: props.value ? props.value.format(props.format) : ''
        };

        this.ref = {
            input: React.createRef(),
            datepicker: React.createRef()
        };
    }

    static defaultProps = {
        className: null,
        style: {},
        align: 'center',
        direction: 'ltr',
        label: null,
        placeholder: '____/__/__',
        id: null,
        name: null,
        readOnly: false,
        disabled: false,
        value: null,
        format: 'jYYYY-jMM-jDD',
        min: undefined,
        max: undefined,
        onEnter: _ => null,
        onChange: _ => null,
        onClick: _ => null,
        onFocus: _ => null,
        onBlur: _ => null,
        validation: _ => true
    };

    static propTypes = {
        className: PropTypes.string,
        style: PropTypes.object,
        align: PropTypes.oneOf(['left', 'center', 'right']),
        direction: PropTypes.oneOf(['ltr', 'rtl']),
        label: PropTypes.string,
        placeholder: PropTypes.string,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
        readOnly: PropTypes.bool,
        disabled: PropTypes.bool,
        value: PropTypes.object,
        format: PropTypes.string,
        min: PropTypes.object,
        max: PropTypes.object,
        onEnter: PropTypes.func,
        onChange: PropTypes.func,
        onClick: PropTypes.func,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        validation: PropTypes.func
    };

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        if (this.props.value !== nextProps.value) {
            nextState.value = nextProps.value;
            nextState.typed = nextProps.value ? nextProps.value.format(nextProps.format) : '';
        }

        return this.state.disabled !== nextState.disabled ||
            this.state.readOnly !== nextState.readOnly ||
            this.state.error !== nextState.error ||
            this.state.value !== nextState.value ||
            this.state.typed !== nextState.typed ||
            this.props.readOnly !== nextProps.readOnly ||
            this.props.disabled !== nextProps.disabled ||
            this.props.className !== nextProps.className ||
            this.props.value !== nextProps.value;
    }

    render () {
        const {state, props} = this;
        const cls = ['Date', props.align];
        const readOnly = state.readOnly || props.readOnly;
        const disabled = state.disabled || props.disabled;
        const id = props.id || state.id;
        let label = null;

        !readOnly && !disabled && state.error && cls.push('error');

        props.className && cls.push(props.className);
        readOnly && cls.push('read-only');
        disabled && cls.push('disabled');
        props.label && (label = <label className={'Date-label'} htmlFor={id}>{props.label}</label>);

        return <div className={cls.join(' ')} style={props.style}>
            {label}
            <div className={'Date-area'}>
                <input ref={this.ref.input}
                       type={'text'}
                       className={'Date-input'}
                       id={id}
                       name={props.name || id}
                       placeholder={props.placeholder}
                       value={state.typed || ''}
                       readOnly={readOnly}
                       disabled={disabled}
                       autoComplete="off"
                       onKeyPress={this.inputKeyPressHandler.bind(this)}
                       onFocus={props.onFocus}
                       onBlur={this.inputBlurHandler.bind(this)}
                       onChange={this.inputChangeHandler.bind(this)}
                       onClick={props.onClick}
                       style={{direction: props.direction}}/>
                <img className={`Date-component ${readOnly ? 'read-only' : ''} ${disabled ? 'disabled' : ''}`} src={Resource.IMAGE.PACK.CALENDAR} onClick={this.componentClickHandler.bind(this)} alt={''}/>
            </div>
            {state.error && <p className={'Input-error'}>{state.error}</p>}
            <DatePicker ref={this.ref.datepicker}
                        value={state.value || moment()}
                        min={props.min}
                        max={props.max}
                        onHide={this.datepickerChangeHandler.bind(this)}/>
        </div>;
    };

    componentClickHandler (event) {
        const {props} = this;

        if (!props.disabled && !props.readOnly) {
            this.ref.datepicker.current.show(this.ref.input.current.getBoundingClientRect());

            props.onClick(event);
        }
    }

    datepickerChangeHandler (moment, enter = false) {
        const {props} = this;

        if (moment && moment.format() !== 'Invalid date') {
            this.setState({value: moment, typed: moment.format(props.format)}, _ => {
                if (this.validate()) {
                    props.onChange(this.state.value);
                    if (enter === true)
                        setTimeout(_ => {
                            props.onEnter(this.state.value);
                        }, 500);
                }
            });
        } else {
            this.setState({value: null, typed: ''}, _ => {
                this.props.onChange(null);
            });
        }
    };

    inputBlurHandler (enter = false) {
        const {state, props} = this;
        let value;
        try {
            value = moment(state.typed, props.format);

            if (props.min && props.min.isSameOrAfter(value, 'jday')) {
                // value = props.min;
                value = null;
                new Notif({message: `تاریخ قبل ${props.min.format(props.format)} نمی تواند باشد.`});
            }

            if (props.max && props.max.isBefore(value, 'jday')) {
                // value = props.max;
                value = null;
                new Notif({message: `تاریخ بعد ${props.max.format(props.format)} نمی تواند باشد.`});
            }

        } catch (e) {
            value = moment('Invalid date');
        }
        this.datepickerChangeHandler(value, enter);
    }

    inputChangeHandler (event) {
        const value = event.target.value;

        this.setState({typed: value});
    }

    inputKeyPressHandler (event) {
        if (event.charCode === 13) {
            this.inputBlurHandler(true);
        }
    }

    error (prompt = null) {
        this.setState({error: prompt});
    }

    disabled (disabled = false) {
        this.setState({disabled});
    }

    readOnly (readOnly = false) {
        this.setState({readOnly});
    }

    value () {
        const {state} = this;

        return state.value ? state.value : null;
    }

    focus () {
        this.ref.input.current.focus();
    }

    validate (value = this.state.value) {
        const {props} = this;
        const validate = props.validation(value);

        if (validate === true)
            this.error();
        else
            this.error(validate);

        return validate === true ? true : {
            label: props.label || props.placeholder || '',
            message: validate
        };
    }
}

class DatePicker extends Component {
    constructor () {
        super();

        this.state = {
            bound: {},
            display: false
        };

        this.ref = {
            parent: React.createRef()
        };
    }

    static defaultProps = {
        value: null,
        min: undefined,
        max: undefined,
        onHide: _ => null
    };

    static propTypes = {
        value: PropTypes.object,
        min: PropTypes.object,
        max: PropTypes.object,
        onHide: PropTypes.func
    };

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        return this.props !== nextProps ||
            this.state.display !== nextState.display;
    }

    render () {
        const bound = {width: 230, height: 300};
        let left = this.state.bound.left;
        let top = this.state.bound.bottom;

        if (left + bound.width > window.innerWidth)
            left = window.innerWidth - bound.width - 20;
        if (top + bound.height > window.innerHeight)
            top = window.innerHeight - bound.height;

        return ReactDOM.createPortal(this.state.display && <div ref={this.ref.parent} className={`DatePickerArea`} style={{left, top}}>
            <div className="DatePickerBody">
                <Calendar isGregorian={false}
                          value={this.props.value}
                          min={this.props.min}
                          max={this.props.max}
                          onChange={this.calendarChangeHandler.bind(this)}/>
            </div>
        </div>, document.getElementById('root'));
    }

    calendarChangeHandler (moment) {
        this.props.onHide(moment);

        this.hide(true);
    }

    show (bound) {
        this.setState({display: true, bound});

        document.addEventListener('click', this.hide.bind(this), true);
    }

    hide (event) {
        if (!this.isInsideDatePickerArea(event?.target) || event === true) {
            document.removeEventListener('click', this.hide.bind(this));
            this.setState({display: false});
        }
    }

    isInsideDatePickerArea (event) {
        if (event?.className === 'DatePickerArea')
            return true;

        if (event?.parentNode)
            return this.isInsideDatePickerArea(event?.parentNode);

        return false;
    }
}

export default Date;